<template>
<div>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
      <v-snackbar centered v-model="snackbar" :color="snackbar_color" :timeout="2000" >
        <span>{{snackbar_message}}</span>
      </v-snackbar>
      <v-card class="neu-glow pb-3 mb-5">
        <v-card-title primary-title>
          <div class="text-h5">Combinazioni Tavoli</div>
          <v-spacer></v-spacer>
          <v-div class="mr-n5 mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="openAdd_Dialog()">
                  <v-icon color="info">mdi-puzzle-edit</v-icon>
                </v-btn>
              </template>
              <span>Inserisci/Elimina</span>
            </v-tooltip>
            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_verifyCombinations=true">
                  <v-icon color="info">mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Verifica</span>
            </v-tooltip>
            
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction_add=true">
                  <v-icon color="info">mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>                
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData()">
                  <v-icon color="info">mdi-sync-circle</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>                                     
          </v-div> 
        </v-card-title>
        <v-row v-if="!allLocations">
            <v-col class="text-center mx-8">
              <v-progress-linear
                color="info"
                height="10"
                indeterminate
                striped
              ></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-else class="pl-8">
         

            <v-tabs
              color="info"
              elevation="8"
              v-model="hallId"
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
            >
              <v-tabs-slider color="info"></v-tabs-slider>
              <template v-for="(h,hi) in allHalls" >
                <v-tab
                  :key=hi
                  :href="'#'+h.hallId"
                  class="font-weight-bold"
                >
                  {{h.text}}
                </v-tab>
                <v-tab-item :key=h :id="h.hallId" class="my-3 pl-5 mr-3 pb-3" :style="'max-height:' + wHeight-200 + 'px;overflow-y:scroll;overflow-x:hidden'" >
                  <v-card class="px-4">
                    <v-row>
                      <v-col cols="1">
                        Coperti
                      </v-col>
                      <v-col cols="11">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                              Combinazioni
                            </div>
                          </template>
                          <span>Combinazioni di tavoli che supportanto i coperti</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row v-if="!allCombinations">
                      <v-col cols="12" class="text-center pt-5 text-h6">
                        Nessuna Combinazione Definita
                      </v-col>
                    </v-row>
                    <v-row class="my-1" v-else :key="ti" v-for="(t,ti) in allCombinations.filter(t=>t.hallId==h.hallId&&t.covers>0)">
                      <v-col cols="1" class="py-2">
                        <v-btn class="info">{{t.covers}}</v-btn>
                      </v-col>
                      <v-col cols="11" class="py-2">
                        <v-btn small v-for="(c,ci) in t.combinations" :key="ci" class="mr-1 mb-2 info">
                          {{c}}
                        </v-btn>                        
                      </v-col>
                      <v-divider></v-divider>
                      <!--
                      <v-col cols="1" class="py-2">
                          <v-text-field
                          dense
                          label=""
                          :value="t.covers"
                          reverse
                          outlined
                          hide-details
                          readonly
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="11" class="py-2">
                        <v-text-field
                          dense
                          label=""
                          outlined
                          readonly
                          :value="t.combinations"
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      -->
                    </v-row>
                  </v-card>
                </v-tab-item>
              </template>
            </v-tabs>

          
        </v-row>
      </v-card>
  </v-form>
  <v-dialog v-model="dialog_addCombinations" fullscreen v-if="hallId" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar height="72">           
          <v-toolbar-title class="text-h5 mt-n2 mr-3">Aggiungi Combinazioni</v-toolbar-title>
            <v-toolbar-items class="pt-2">
                <div class="d-flex">
                  <v-btn-toggle
                    group
                    v-model="activeHallId"
                    active-class="info white--text"
                    class="d-flex flex-wrap px-1"
                  >
                    <v-col class="text-center" v-for="(h,hi) in allHalls" :key="hi">
                      <v-btn small :value="h.hallId" class="neu-glow">
                        <span class="font-weight-black" v-html="h.text"></span>
                      </v-btn>
                    </v-col>
                  </v-btn-toggle>
                </div>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-4">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="covers<2?1:covers--">
                      <v-icon color="error">mdi-arrow-down-bold-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Diminuisci Coperti</span>
              </v-tooltip>
              <span class="font-weight-bold text-h4 pl-2 pr-4 ">{{covers}}</span>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3"  @click="covers>50?50:covers++" >
                      <v-icon color="success">mdi-arrow-up-bold-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Aumenta Coperti</span>
              </v-tooltip>

            </v-toolbar-items>
            <v-toolbar-items class="pt-4">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small :disabled="tempCombination&&!tempCombination.length" class="neu-glow mr-3" @click="addCombination()">
                      <v-icon color="success">mdi-thumb-up</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Inserisci</span>
              </v-tooltip>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-4">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="tempCombination&&!tempCombination.length"  @click="removeCombination()">
                      <v-icon color="error">mdi-thumb-down</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Rimuovi</span>
              </v-tooltip>
              <!--
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3"  @click="addAllTables()">
                      <v-icon color="info">mdi-alpha-t-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Tutti i Tavoli</span>
              </v-tooltip>
              --> 
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="cancelCombinations()">
                      <v-icon color="warning">mdi-alpha-c-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Cancella Riga Combinazioni</span>
              </v-tooltip>                                                            
            </v-toolbar-items>
          
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-4">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <!--:disabled="allCombinations_hash==JSON.stringify(allCombinations)"-->
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading_update" :disabled="allCombinations_hash==JSON.stringify(allCombinations)" @click.stop="saveCombinations()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_instruction=true">
                      <v-icon color="info">mdi-help-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_addCombinations=false">
                      <v-icon color="info">mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar-items>
          </v-toolbar>


          <template v-if="allCombinations">
            <v-card class="mt-3 neu-glow">
              <v-row v-for="(c,i) in allCombinations.filter(t=>t.hallId==activeHallId&&t.covers==covers)" :key="i">
                <v-col cols="1" class="pl-8">
                  <v-btn small class="info mb-2">{{c.covers}}</v-btn>                   
                </v-col>
                <v-col cols="11" class="pr-8">
                  <v-btn
                    v-model="selectedCombination"
                    small
                    class="info mr-1 mb-2"
                    v-for="(e,ei) in c.combinations"
                    :key="ei"
                    :value="e"
                    @click="slctCombination(e)"
                  >
                    {{e}}
                  </v-btn>               
                </v-col>
              </v-row>
            </v-card>
          </template>
          <v-row class="mx-3 mt-8">
            <v-card :max-height="wHeight-300" class="pt-2" style="overflow: hidden scroll">
              <v-row class="justify-space-around mb-0">
                <v-col class="pa-1" :key="ti">
                  <div :style="'width:'+(wWidth*.95)+'px;height:'+(wHeight-200)+'px;position: relative'">
                    <v-btn-toggle v-model="tempCombination" multiple active-class="info" class="d-flex flex-row">
                        <v-btn
                          v-for="(t,ti) in allTables.filter(t=>t.hallId==activeHallId)"
                          :key="ti"
                          v-bind="attrs" v-on="on" 
                          absolute
                          :value="t.name" 
                          :class="!t.show?'red--text table-shape-'+[t.shape]:'table-shape-'+[t.shape]"
                          :style="{width: (t.width*zoomLevelFull(t.hallId))+'px',height: (t.height*zoomLevelFull(t.hallId))+'px',left:(t.xPos*zoomLevelFull(t.hallId))+'px',top:(t.yPos*zoomLevelFull(t.hallId))+'px',transform:'rotate('+t.angle+'deg)'}"
                        >
                          <span class="text-h5 font-weight-bold">{{t.name}}</span>
                        </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
              </v-row>
            </v-card>          
          </v-row>
      </v-card>
  </v-dialog>    
  <v-dialog v-model="dialog_verifyCombinations" fullscreen v-if="allCombinations.length&&allCombinations[0].hallId" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar>           
          <v-toolbar-title class="text-h5 pt-4 mr-3">Verifica Combinazioni - Sala</v-toolbar-title>
            <v-toolbar-items class="pt-3">
                <div class="d-flex">
                  <v-btn-toggle
                    v-model="activeHallId2"
                    active-class="info white--text"
                    class="d-flex flex-wrap px-1"
                  >
                    <v-col class="text-center" v-for="(h,hi) in allHalls" :key="hi">
                      <v-badge
                        bordered
                        color="info"
                        :content="allCombinations.find(c=>c.hallId==h.hallId&&c.covers==covers).combinations?allCombinations.find(c=>c.hallId==h.hallId&&c.covers==covers).combinations.length:'0'"
                        overlap
                      >
                        <v-btn small :value="h.hallId" elevation="5">
                          <span class="font-weight-black" v-html="h.text"></span>
                        </v-btn>
                      </v-badge>
                    </v-col>
                  </v-btn-toggle>
                </div>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-3">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="selectedCombination=null;covers<2?1:covers--">
                      <v-icon color="error">mdi-arrow-down-bold-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Diminuisci Coperti</span>
              </v-tooltip>
              <span class="font-weight-bold text-h4 pl-2 pr-4 pt-1">{{covers}}</span>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3"  @click="selectedCombination=null;covers<1?1:covers++" >
                      <v-icon color="success">mdi-arrow-up-bold-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Aumenta Coperti</span>
              </v-tooltip>
            </v-toolbar-items>

            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-1">
              <v-text-field 
                v-bind="attrs" v-on="on"
                label="Inserisci Combinazione"
                outlined
                dense
                v-model="newCombination"
                class="centered-input pt-2"
              >
              </v-text-field>
              <v-tooltip right >
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow ml-3 mt-3" :loading="loading_update" @click="addNewCombination()">
                      <v-icon color="success">mdi-thumb-up</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Inserisci</span>
              </v-tooltip>              
            </v-toolbar-items>            
            <!--
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-2">

              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="addCombination()">
                      <v-icon color="success">mdi-thumb-up</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Inserisci</span>
              </v-tooltip>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-2">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3"  @click="addAllTables()">
                      <v-icon color="info">mdi-alpha-t-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Tutti i Tavoli</span>
              </v-tooltip> 
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3"  @click="removeCombination()">
                      <v-icon color="error">mdi-thumb-down</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Rimuovi</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="cancelCombinations()">
                      <v-icon color="warning">mdi-alpha-c-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Cancella Riga Combinazioni</span>
              </v-tooltip>                                                            
            </v-toolbar-items>
            -->          
            <v-spacer></v-spacer>
            <v-toolbar-items class="pt-3">
            

              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :loading="loading_update" :disabled="allCombinations_hash==JSON.stringify(allCombinations)" @click.stop="saveCombinations()">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_instruction_verify=true">
                      <v-icon color="info">mdi-help-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" @click="dialog_verifyCombinations=false">
                      <v-icon color="info">mdi-close-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-sheet>
          <v-card class="mx-3 pt-2 pb-4 elevation-8">
            <!--<v-row class="mx-4">
                <v-col md="12" cols="12">-->
                  <v-data-table
                    class="h27"
                    dense
                    fixed-header
                    table-striped
                    height="780"
                    :headers="headers"
                    :items="allTables.filter(t=>t.hallId==activeHallId&&t.name!==null)"
                    hide-default-footer
                    :items-per-page=500
                    :loading="loading"
                    no-data-text="Nessun dato presente in archivio"
                    no-results-text="Nessun Risultato estratto"
                    loading-text="Consultazione archivio: attendi..."
                  >
                  
                    <template v-slot:[`item.name`]="{ item }">
                      <div>
                        {{item.name}}
                      </div>
                    </template>

                    <template v-slot:[`item.idx`]="{ item }">
                      
                        <span class="pl-4" v-for="(c, ci) in cmbn(item.name)" :key="ci">
                          {{c}} 
                      </span>
                    </template>   
                                  
                  </v-data-table>
                <!--</v-col>
            </v-row>-->
          </v-card>
          </v-sheet>
        </v-container>
        <!--
        <v-row class="mx-3">
          <v-card max-height="825" class="mt-5 pt-2 pb-4" style="overflow: hidden scroll;width:100%">

            <v-row v-for="(t,ti) in allTables.filter(t=>t.hallId==activeHallId&&t.name)" :key="ti" style="border-bottom: 1px dotted gray;" >
              <v-col cols="1" class="text-center py-2" :key="ti">
                <span class="font-weight-black" v-html="t.name"></span>
              </v-col>
              <v-col cols="11" class="py-2">
                <span class="pl-2" v-for="(c, ci) in allCombinations.find(k=>k.covers==covers&&k.combinations).combinations.map(j=>j).filter(h=>(h.split(',').includes(t.name)))" :key="ci">
                  {{c}}
                </span>
              </v-col>
              <v-divider></v-divider>
            </v-row>
          </v-card>
        </v-row>-->
      </v-card>
  </v-dialog>
  <v-dialog v-model="dialog_instruction" max-width="1000">
      <v-card class="neu-glow pb-1">
          <v-card-title class="text-h5 mb-1">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col md="6" cols="12" class="justify">
                  <p>Selezionare la Sala da Codificare agendo sui pulsanti in alto a sinistra</p>
                  <p>Quindi, Agendo sui pulsanti <v-icon color="error">mdi-arrow-down-bold-circle</v-icon> e <v-icon color="success">mdi-arrow-up-bold-circle</v-icon>  scegliete il numero di coperti per il quale volete inserire le combinazioni:</p>
                  <p>Nella finestra sottostante appariranno le combinazioni già memorizzate (inizialmente sarà vuoto) ed in quella successiva i tavoli relativi alla sala selezionata </p>
                  <p>Quindi inserisci tutte le possibili combinazioni di tavoli da utilizzare per il numero di coperti selezionato.</p>
                  <p>Quindi passare al numero di coperti successivo ed inserire nuovamente tutte le combinazioni possibili per il numero di coperti impostati.</p>
                  <p>Il sistema consente di inserire combinazioni fino ad un massimo di 50 coperti: non è necessario completarle tutte ma inserire, ad esempio, le combinazioni fino a 25 coperti comporta che:
                    <ol>
                      <li>Il sistema non consentirà al cliente di fare prenotazioni in autonomia per più di 25 coperti, ma avviserà che sarà richiamato</li>
                      <li>Il sistema non assegnerà i tavoli per le prenotazioni superiori a 25 coperti che dovranno essere assegnati manualmente prima di fare l'assegnazione automatica</li>
                    </ol>
                  </p>
              </v-col>
              <v-col md="6" cols="12" class="justify">
                  <p>Per registrare una combinazione, cliccare sui relativi pulsanti che diventano azzurri, e quindi cliccare il pulsante <v-icon color="success">mdi-thumb-up</v-icon>.</p>
                  <p>Le combinazioni non tengono conto dell'ordine in cui sono digitati i tavoli: pertanto "A1-A2-A3" equivale ad "A3-A1-A2"</p>
                  <p>Il sistema verifica che la combinazione non sia già stata inserita e nel caso la aggiunge o informa che è già presente.</p>
                  <p>I Tavoli in Rosso sono quelli al momento disabilitati: è possibile comunque utilizzarli per creare combinazioni ma qualora risultassero disabilitati, le combinazioni in cui sono presenti non saranno utilizzate.</p>
                  <p>Per cancellare una combinazione, eseguire la stessa procedura ma cliccare sul pulsante <v-icon color="error">mdi-thumb-down</v-icon>.</p>
                  <p>Il pulsante <v-icon color="info">mdi-alpha-t-circle</v-icon> inserisce tutti i tavoli disponibili: serve, di norma, per velocizzare l'inserimento delle combinazioni per 1 coperto e 2 coperti</p>
                  <p>Il pulsante <v-icon color="warning">mdi-alpha-c-circle</v-icon> cancella tutte le combinazioni per il numero di coperti impostato</p>
                  <p>Una volta terminate le operazioni, i dati vanno salvati. il pulsante <v-icon color="error">mdi-content-save</v-icon> si abilita qualora rilevi i dati siano variati. Premerlo per memorizzare le scelte effettuate.</p>
              </v-col>
              <v-col cols="12">
                  <p class="justify">E' <span class="text--red">ASSOLUTAMENTE importante inserire TUTTE</span> le possibili combinazioni in quanto sia la procedura per l'assegnazione automatica dei tavoli che quella per calcolare se vi sono ancora tavoli liberi utilizzano questi valori.</p>
              </v-col>
          </v-row>
      </v-card>
  </v-dialog>
  <v-dialog v-model="dialog_instruction_add" max-width="600">
      <v-card class="neu-glow pb-1">
          <v-card-title class="text-h5 mb-1">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction_add = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col md="12" cols="12">
                  <p>Le "Combinazioni" sono tutte le combinazioni di tavoli che siete soliti unire quando il numero di coperti è superiore alla capacità dei un tavolo singolo</p>
                  <p>Qui vengono mostrate tutte le combinazioni inserite, suddivise per Sala</p>
                  <p>In questa finestra i dati non sono modificabili.</p>
              </v-col>
              <v-col md="12" cols="12">
                  <p>Per aggiungere, modificare, cancellare le combinazioni, cliccare qui <v-icon @click="dialog_addCombinations_2=false;dialog_addCombinations=true" color="info">mdi-plus-circle</v-icon>.</p>
                  <p>Quindi seguire le istruzioni visualizzabili cliccando sul pulsante <v-icon color="info">mdi-help-circle</v-icon> nella finestra che si apre</p>
              </v-col>
              <v-col cols="12">
                  <p>E' VITALE inserire TUTTE le possibili combinazioni in quanto sia la procedura per l'assegnazione automatica dei tavoli che quella per calcolare se vi sono ancora tavoli liberi utilizzano questi valori.</p>
              </v-col>
          </v-row>
      </v-card>
  </v-dialog>
  <v-dialog v-model="dialog_instruction_verify" max-width="1000">
    <v-card class="neu-glow pb-1">
        <v-card-title class="text-h5 mb-1">
          Istruzioni
          <v-spacer></v-spacer>
          <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction_verify = false">
                  <v-icon color="info">mdi-close</v-icon>
              </v-btn>
              </template>
              <span>Esci</span>
          </v-tooltip>             
        </v-card-title>
        <v-divider></v-divider>
        <v-row class="mx-5 mt-1 mb-0 pb-3">
          <v-col md="12" cols="6">
              <p>Qui vengono mostrate tutte le combinazioni inserite, suddivise per Tavolo, riferite alla sala selezionata</p>
              <p>Il numero sopra il nome della sala indica il numero di combinazioni, mentre il numero tra i due pulsanti <v-icon color="error">mdi-arrow-down-bold-circle</v-icon> e <v-icon color="success">mdi-arrow-up-bold-circle</v-icon> indica il numero di coperti</p>
              <p>E' FONDAMENTALE che per ogni tavolo siano presenti TUTTE le possibili combinazioni, queste, per oltre 3 coperti dovrebbero essere almeno 2-3</p>
              <p>Ipotizzando che per 2 coperti siano (come consigliato) selezionati tutti i tavoli si consiglia di essere particolarmente attenti nell'inserimento delle combinazioni con un range di coperti da 3 a 8 in quando sono quelli che oltre ad avere una frequenza maggiore, sono quelli che consentono di riempire la sala</p>
              <p>In questa finestra i dati non sono modificabili, ma è possibile inserire delle combinazioni dal riquadro in alto.</p>
          </v-col>
          <v-col md="12" cols="6">
              <p>Lo scopo di questa pagina è appunto quello di mostrare i dati relativi al singolo tavolo in modo da visualizzare agevolmente eventuali carenze.</p>
              <p>La sintassi dell'inserimento richiede che vengano inseriti i nomi dei tavoli separati dal segno meno (-): esempio B1-B2</p>
              <p>Una volta cliccato sul pulsante Inserisci, Il sistema verifica la correttezza della sintassi, che la combinazione non sia già presente e che i tavoli inseriti siano presenti nella sala selezionata</p>
              <p>Se l'esito delle verifiche è positivo la combinazione viene aggiunta in tempo reale</p>
              <p>ATTENZIONE: dopo aver fatto delle modifiche il pulsante <v-icon color="error">mdi-content-save</v-icon></p> si attiva: prima di uscire dalla pagina cliccarlo per memorizzare le modifiche apportate.
          </v-col>
        </v-row>
    </v-card>
  </v-dialog>   
</div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_instruction_add:false,
      dialog_instruction_verify:false,
      dialog_verifyCombinations:false,
      dialog_addCombinations:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      allTables:null,
      allHalls:null,
      locationId:null,
      hallId:null,
      activeHallId:[],
      activeHallId2:[],
      currentHall:null,
      tableId:null,
      allLocations:null,
      allCombinations_empty:[{hallId:null,covers:null,combinations:null}],
      allCombinations:[],
      allCombinations_hash:null,
      message:null,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:'',
      tempCombination:[],
      combinations:'',
      newCombination:null,
      covers:1,
      userId:null,
      hallCols:null,
      tCombination:null,
      refreshTrigger:false,
      selectedCombination:null,
        //comb:{hallId:null,covers:["","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","","",""]},
      cc:{hallId:null,covers:0,combinations:''},
      combArray:[],
      headers: [
          { text: 'Tavolo',       value: 'name',   align: 'center', sortable: true, width: "10%", class:'text-lg-button' },
          { text: 'Combinazioni', value: 'idx',    align: 'start',  sortable: true, width: "90%", class:'text-lg-button' }
      ] 
      /*
         {
      "hallId": "1B8AC602947E2C1DC3A2796EBDE38AA1DBF3E663",
      "covers": 0,
      "combinations": ""
   },
   */
      
    };
  },
  computed : {
    ...mapGetters(["settings"]),
    /*
    thisHall(){
      console.log(186,this.locationId,this.hallId);
      this.currentHall=this.allTables.filter(t =>t.hallId===this.hallId)
      console.log(188,this.currentHall);
      return this.currentHall
    }*/
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    'comb.covers': function (newVal, oldVal)
    {
      console.log(370,newVal,oldVal)
    }
  },
  methods:
  {
    slctCombination(tname)
    {
      console.log(752,tname)
      var tblsArray=tname.split('-')
      console.log(741,tblsArray)
      this.tempCombination=tblsArray;
    },
    zoomLevelFull(hallId)
    {
      
      var mWidth=this.allHalls.find(h=>h.hallId==hallId).maxWidth;
      var zoomWidth=this.wWidth*.92/mWidth;
      var mHeight=this.allHalls.find(h=>h.hallId==hallId).maxHeight;
      var zoomHeight=(this.wHeight-250)/mHeight;
      var zl=Math.min(zoomWidth,zoomHeight,1.5)
      //console.log(4979,mWidth,mHeight,zoomWidth,zoomHeight,zl)
      //console.log(hallId)
      return zl;     
    },
    cmbn(t)
    {
      var cmb = this.allCombinations.find(k=>k.combinations&&k.covers==this.covers&&k.hallId==this.activeHallId)
        ?this.allCombinations.find(k=>k.covers==this.covers&&k.hallId==this.activeHallId&&k.combinations).combinations.map(j=>j).filter(h=>(h.split('-').includes(t)))
        :null;
      //console.log(763,cmb);
      return cmb;
    },
    openAdd_Dialog()
    {
      this.dialog_addCombinations=true;
      //this.allCombinations.filter(t=>t.hallId==this.hallId).forEach(e=> this.comb[e.covers]=e.combinations); //.replace('[','').replace(']',''));
      //console.log(379,this.comb);
    },
    async saveCombinations()
    {
        this.loading_update=true;
        console.log(254,this.allCombinations);
        var allCombinations=[...this.allCombinations];
        console.log(255,allCombinations);
        allCombinations.forEach(c=>c.combinations=JSON.stringify(c.combinations));
        console.log(256,allCombinations);
        let payload={"action":"saveItem","table":"TablesCombinations","payload":allCombinations};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.getData();
        }   
    },    
    addAllTables()
    {
      //var v=this.allTables.filter(f=>f.hallId==this.hallId).map(n=>n.name).join(',');
      var v=this.allTables.filter(f=>f.hallId==this.activeHallId&&f.name).map(n=>n.name);

      console.log(835,v);
      this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations=v;
      console.log(837,this.allCombinations)
      //this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations
    },
    addCombination()
    {
      console.log(848,this.tempCombination,this.activeHallId,this.covers,this.tCombination);
      console.log(849,this.allCombinations)
      var str=this.tempCombination.join('-');
      var arr=[...this.tempCombination];
      this.tCombination=[];
      this.tempCombination=[];
      if (this.$refs.createCombinationsCanvas)
      {
        this.$refs.createCombinationsCanvas.resetTables();
      }
      console.log(858,str,arr);   
      var ce=this.allCombinations.length?this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations:null;

      var cnt=0;
      var min=99;
      var alength=arr.length;
      if(!ce)
      {
        min=1;
      }
      else
      {      
        ce.forEach(c=>
          {        
            var celength=c.split('-').length;
            cnt=c.split('-').filter( ( el ) => !arr.includes( el )).length
            console.log (c.split('-').length,c,cnt,alength===celength)
            if (alength===celength)
            {
              min=Math.min(min,cnt);
            }
          })
      }
        if (min>0)
      {
        console.log(883,'add',min,cnt,arr)
        this.snackbar_message='Combinazione Aggiunta';
        this.snackbar_color='success'
        this.snackbar=true;
        if (Array.isArray(ce))
        {
          //ce.push(str);
          //console.log(870,JSON.stringify(ce),ce)
          this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.push(str)
        }
        else
        {
          console.log(895,this.allCombinations)
          this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations=[];
          this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.push(str)
        }   
        console.log(899,this.allCombinations) 
      }
      else
      {
        console.log('ko')
        this.snackbar_message='Combinazione già presente';
        this.snackbar_color='error'
        this.snackbar=true;      
      }
    },
    addNewCombination()
    {
      console.log(331,this.newCombination,this.activeHallId,this.covers);
      var str=this.newCombination.toUpperCase();
      this.newCombination=null;
      var arr=str.split('-');
      console.log(414,str);
      var ce=this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations;
      console.log(793,ce,this.covers,this.activeHallId)
      var max=0;
      var cnt=0;
      var xs=0;// table name exists
      if(ce)
      {
        ce.forEach(cnb=>{
          cnt=0;
          xs=0;
          arr.forEach(c=>{ 	
            cnt+=cnb.includes(c);
            xs+=this.allTables.find(t=>t.name===c)?1:0;
            console.log(848,xs)
          });
          max=Math.max(max,cnt)
        });
      }
      console.log(854,arr.length,max,xs,'add')
      if ((arr.length>max||!ce) && arr.length===xs)
      {
        console.log(857,'add')
        this.snackbar_message='Combinazione Aggiunta';
        this.snackbar_color='success'
        this.snackbar=true;
        if (Array.isArray(ce))
        {
          ce.push(str);
          console.log(890)
        }
        else
        {
          console.log(426)
          this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations=[];
          this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.push(str)
        }      
      }
      else
      {
        if (arr.length!==xs)
        {
          console.log('ko2')
          this.snackbar_message='Tavolo/i non presenti in questa Sala';
          this.snackbar_color='error'
          this.snackbar=true;
        }
        else
        {
          console.log('ko')
          this.snackbar_message='Combinazione già presente';
          this.snackbar_color='error'
          this.snackbar=true;
        }
        this.refreshTrigger=!this.refreshTrigger;
      }
      //console.log(415,cc,cd,ce);
      //this.allCombinations.filter(t=>t.hallId==this.hallId&&t.covers==this.covers).combinations.push(str);
      //console.log(420,this.allCombinations);
      //console.log(423,JSON.stringify(this.allCombinations))
      
    },    
    async removeCombination()
    {
      console.log(925,this.tempCombination,this.tCombination,this.activeHallId,this.covers);
      //var str=this.tempCombination.join(',');
      var arr=this.tCombination;
      var arr2=this.tempCombination;
      console.log(930,arr,arr2)
      this.tCombination=[];
      this.tempCombination=[];
      //console.log(414,str);
      let payload={"action":"Combinations_Used_get","table":"","payload":{"covers":this.covers}};
      console.log(935,payload)
      let uc= await this.updateDB(payload)
      let usedCombinations=[];
      let usedCombination=false;
      switch (uc.errorid)
      {
        case '0':
          sessionStorage.setItem('jwt', uc.jwt);
          usedCombinations=uc.payloads;
          console.log(944,usedCombinations)
      break;
      case '0006':
          this.$router.push('/auth/login').catch(() => {});
      break;
      }
      if(usedCombinations.length)
      {
        console.log(952,usedCombinations,arr,this.tCombination)
        var cnt=0;
        var max=0;
        var c1='';
        var t1=''
        usedCombinations.forEach((c,i)=>{
          cnt=0;
          arr2.forEach(t=>{
            c1='-'+c.tables+'-';
            t1='-'+t+'-';
            console.log(962,c,t,i,c1,t1,c1.includes(t1))
            cnt+=(c1).includes((t1))            
          })
          max=Math.max(max,cnt)
          console.log(966,max,arr2.length,cnt)
          if (arr2.length==max)
          {
            console.log(969)
            usedCombination=true;
          }
        })
      }

      if(usedCombination)
      {
        this.snackbar_message='Combinazione in uso: Impossibile cancellare';
        this.snackbar_color='error'
        this.snackbar=true;
      }
      else
      {
        var ce=this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations;
        console.log(984,ce)
        max=0;
        cnt=0;
        var done=0;
        c1=''
        var n1=''
        if(ce)
        {
          ce.forEach((n,i)=>{
            cnt=0;
            arr2.forEach(c=>{
              n1='-'+n+'-';
              c1='-'+c+'-';
              console.log(997,n1,i,c1,n1.includes(c1))
              cnt+=(n1).includes((c1))
              });
            max=Math.max(max,cnt)
            console.log(1001,max,arr2.length,cnt)
            if (arr2.length==max)
            {
              console.log(1004,'remove')

              this.snackbar_message='Combinazione Rimossa';
              this.snackbar_color='success'
              this.snackbar=true;
              console.log(1008,i,JSON.stringify(this.allCombinations))
              console.log(1009,i,this.allCombinations)
              console.log(1010,this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations)
              /*
              if(i==0&&this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.length==1)
              {
                this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations=null;
              }
              else
              {
                this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.splice(i,1)
              }
              */
             this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations.splice(i,1)
              console.log(1034,i,this.allCombinations)
              console.log(1035,i,JSON.stringify(this.allCombinations))
              done=1;
              max=0;
            }
          });
        }

        if (done==0)
        {
          console.log('ko')
          this.snackbar_message='Combinazione non presente';
          this.snackbar_color='error'
          this.snackbar=true;
        } 
      } 
      if(this.$refs.createCombinationsCanvas)
      {
        this.$refs.createCombinationsCanvas.resetTables();
      }
    },
    cancelCombinations()
    {
      console.log(415,this.tempCombination,this.activeHallId,this.covers);
      console.log(469,this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations)
      this.allCombinations.find(t=>t.hallId==this.activeHallId&&t.covers==this.covers).combinations=[];
    },
    async getData()
    {
        {
            this.loading=true;
            try{
                const payload=JSON.stringify({"sortOrder": "sortByTableNumber","action":"AllCombinations_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                switch (res.data.errorid)
                {
                  case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.userId=res.data.payloads.userId
                    this.allLocations=res.data.payloads.allLocations;
                    this.allHalls=res.data.payloads.allHalls;
                    this.activeHallId=this.allHalls[0].hallId;
                    this.allTables=res.data.payloads.allTables;
                    this.allCombinations=res.data.payloads.allCombinations||this.allCombinations_empty;
                    this.allCombinations_hash=JSON.stringify(this.allCombinations);
                    console.log(282,this.allLocations,this.allHalls,this.allTables,this.allCombinations)
                    console.log(1116,this.userId)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
  beforeDestroy() {
    console.log(1060);
    this.dialog_instruction=true;

  }
};
</script>
<style scoped>
.col-20 {
    -ms-flex: 0 0 5%;
    flex: 0 0 5%;
    max-width: 5%;
}
.minh-30{
  min-height:30px!important;
}
.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot{
   min-height:30px!important;
}
.v-data-table--dense.h27>.v-data-table__wrapper>table>tbody>tr>td{
  height:26px!important
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03);
}
</style>

<style scoped>
.v-btn.table-shape-rounded{
    border-radius: 10px !important;
}
.v-btn.table-shape-round{
    border-radius: 50% !important;
}
.text-mini{
    font-size: .65rem !important;
}
.text-micro{
    font-size: .55rem !important;
}
.v-data-table-header th {
  white-space: nowrap;
}

</style>